import { Avatar as RawAvatar, styled } from '@arpeggi/ui'
import { ContributorsDisplay } from '../../../__legacy__/components/platform/explore/common/Contributors'

const Root = styled('div', {
  display: 'flex',
  alignItems: 'center',
  marginBottom: '32px'
})

const AvatarGroup = styled('div', {
  display: 'flex',
  flexDirection: 'row-reverse',
  '& > *': {
    marginRight: `-8px`
  },
  marginRight: '16px'
})

const Avatar = styled(RawAvatar, {
  width: '24px',
  height: '24px',
  borderStyle: 'solid',
  borderColor: '$white',
  borderWidth: '2px'
})

const Display = ContributorsDisplay.bind({})
Display.defaultProps = {
  noText: true,
  maxContributors: 12,
  avatarSize: '24px'
}

const Count = styled('div', {
  background: '$whiteA700',
  borderRadius: '9999px',
  boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.05)',
  lineHeight: '20px',
  fontWeight: 500,
  fontSize: '$12',
  padding: '0px 12px'
})

export const Contributors = { Root, Display, Count, AvatarGroup, Avatar }
